export const homeFeaturedWorks = ["work-1", "work-2", "work-3", "work-4"];

export const homeFeaturedArticles = ["article-1", "article-2", "article-3"];

export const heroData = {
  title: "风间由美",
  subtitle: "用演技诠释人生，以真诚打动人心",
  description: "日本知名女演员与艺人，汇聚最新动态、作品履历、演艺生涯精华及粉丝专属内容",
  ctaText: "探索更多",
  ctaLink: "/category/all",
  image: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20actress%20artistic%20portrait%20with%20soft%20warm%20cinematic%20lighting%2C%20sophisticated%20and%20graceful%20pose%2C%20beautiful%20feminine%20silhouette%2C%20minimalist%20composition%2C%20warm%20golden%20and%20cream%20tones%2C%20professional%20celebrity%20photography%20style&width=1600&height=900&seq=hero-main&orientation=landscape",
};

export const galleryImages = [
  {
    id: "gallery-1",
    src: "https://readdy.ai/api/search-image?query=Japanese%20actress%20elegant%20photoshoot%2C%20soft%20natural%20lighting%2C%20minimalist%20studio%20setting%2C%20warm%20neutral%20tones%2C%20graceful%20pose%2C%20professional%20fashion%20photography&width=600&height=400&seq=gallery-1&orientation=landscape",
    alt: "风间由美写真照",
  },
  {
    id: "gallery-2",
    src: "https://readdy.ai/api/search-image?query=Japanese%20actress%20at%20film%20festival%2C%20elegant%20evening%20dress%2C%20red%20carpet%20moment%2C%20warm%20golden%20lighting%2C%20glamorous%20atmosphere%2C%20event%20photography&width=600&height=400&seq=gallery-2&orientation=landscape",
    alt: "风间由美电影节红毯",
  },
  {
    id: "gallery-3",
    src: "https://readdy.ai/api/search-image?query=Japanese%20actress%20casual%20outdoor%20lifestyle%20photo%2C%20cherry%20blossom%20garden%2C%20spring%20atmosphere%2C%20natural%20warm%20lighting%2C%20beautiful%20scenery%2C%20artistic%20portrait%20photography&width=600&height=400&seq=gallery-3&orientation=landscape",
    alt: "风间由美生活照",
  },
  {
    id: "gallery-4",
    src: "https://readdy.ai/api/search-image?query=Japanese%20actress%20on%20movie%20set%2C%20professional%20filming%20scene%2C%20cinematic%20lighting%2C%20behind%20the%20scenes%2C%20creative%20atmosphere%2C%20warm%20dramatic%20tones&width=600&height=400&seq=gallery-4&orientation=landscape",
    alt: "风间由美拍摄现场",
  },
  {
    id: "gallery-5",
    src: "https://readdy.ai/api/search-image?query=Japanese%20actress%20fan%20meeting%20event%2C%20smiling%20and%20waving%2C%20cheering%20crowd%2C%20warm%20stage%20lighting%2C%20heartwarming%20atmosphere%2C%20event%20photography&width=600&height=400&seq=gallery-5&orientation=landscape",
    alt: "风间由美粉丝见面会",
  },
  {
    id: "gallery-6",
    src: "https://readdy.ai/api/search-image?query=Japanese%20actress%20artistic%20black%20and%20white%20portrait%2C%20dramatic%20shadows%2C%20elegant%20timeless%20style%2C%20fine%20art%20photography%2C%20minimalist%20composition%2C%20sophisticated%20mood&width=600&height=400&seq=gallery-6&orientation=landscape",
    alt: "风间由美艺术写真",
  },
];

export const faqData = [
  {
    question: "风间由美的最新作品是什么？",
    answer: "风间由美最新主演的电影是《深夜的诱惑》，该片于2026年7月上映，由山田太郎执导，上映首周票房即突破10亿日元。您可以在本站的作品页面查看完整作品列表。",
  },
  {
    question: "如何加入风间由美官方粉丝俱乐部？",
    answer: "您可以通过本站的粉丝专区了解加入方式。官方粉丝俱乐部目前拥有超过50万会员，加入后可享受专属福利，包括限量周边、线上见面会名额和签名照等。",
  },
  {
    question: "风间由美近期有哪些公开活动？",
    answer: "请关注本站的最新动态栏目以及风间由美官方社交媒体账号（Twitter、Instagram），我们会第一时间更新所有公开活动信息。",
  },
  {
    question: "风间由美获得过哪些重要奖项？",
    answer: "风间由美凭借《月光之城的秘密》获得第50届日本电影学院奖最佳女主角提名。此外，她在其15年以上的演艺生涯中获得了12次各类重要奖项提名和荣誉。",
  },
  {
    question: "风间由美会举办海外粉丝见面会吗？",
    answer: "目前风间由美主要在日本国内举办粉丝活动。关于海外活动的计划，请持续关注本站的官方公告和社交媒体更新。",
  },
];